//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import _ from 'underscore'

export default {
  components: {
    DialogDetailOrder: () => import('@/index/pages/operate/order/orderTabs/components/DialogDetailOrder/index.vue')
  },
  props: {
    tableData: {
      default: () => []
    },
    searchData: {
      default: () => ({})
    },
    loading: {
      default: false
    }
  },
  data: function () {
    return {
      readTypeOptions: [
        {value: -1, label: '全部'},
        {value: 0, label: '未读'},
        {value: 1, label: '已读'}
      ],
      form: _.extend({}, this.searchData),
      currentTableData: this.tableData,
      multipleSelection: [],
      rowData: {
        default: () => ({})
      },
      detailDialogVisible: false
    }
  },
  watch: {
    form: {
      handler (val) {
        this.$emit('update:searchData', val)
      },
      deep: true
    },
    tableData: {
      handler (val) {
        this.currentTableData = val
      },
      immediate: true
    }
  },
  methods: {
    handleSelectable (row, index){
      return row.unReadCount === 0 ? false : true
    },
    handleSelectionChange (val) {
      this.multipleSelection = val;
    },
    handleMarkReaded(){
      if (this.multipleSelection.length > 0) {
        let data = {
          items: []
        }
        _.each(this.multipleSelection, (t)=>{
          data.items.push(_.pick(t, 'orderId', 'type'))
        })
        data.items = JSON.stringify(data.items)
        this.$axios.post('/mtea/store/admin/msg/read', data).then(res => {
          this.multipleSelection = []
          this.$emit('submit')
          this.$notify.success({
            title: '系统提示',
            message: '操作成功'
          })
          this.$axios.get('/mtea/store/admin/msg/unReadCount', { params: {} }).then(res => {
            let count = _.reduce(res, (memo, item) => { return memo + item.count }, 0);
            console.log('count', count)
            this.$bus.$emit('menuDotShow', { menu: { path: '/operate/msg/tabs' }, count: count})
          })
        }).finally(() => {

        })
      }
    }
  }
}
